import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setAuth } = useAuth();
  const ran = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = loc.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setAuth(data);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(()=>nav("/login"), 1500);
      }
    })();
  }, [loc, nav, setAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center text-stone-700">
      {error ? <div data-testid="auth-callback-error">{error}</div> : <div data-testid="auth-callback-loading">Signing you in…</div>}
    </div>
  );
}
